import useAuth from '../../auth/authContext';
import { youtubeConfig } from '../../commons/config';

export const useIsYouTubeEnabled = () => {
  const {
    state: { user },
  } = useAuth();
  const isYouTubeEnabled =
    youtubeConfig.enabled &&
    !!user &&
    (youtubeConfig.restrictedDomainsOnly.length === 0 ||
      !!(
        user.email &&
        youtubeConfig.restrictedDomainsOnly.some((d) =>
          user.email.toLowerCase().endsWith(`@${d.toLowerCase()}`)
        )
      ));
  return { isYouTubeEnabled };
};

